export const prefix = '[Permissions]';
